document.addEventListener('DOMContentLoaded', function() {
  
  // --- Get all the necessary elements with unique selectors ---
  const openModalBtn = document.getElementById('custom-fragrance-selector-btn');
  const modal = document.getElementById('custom-fragrance-modal');
  const closeModalBtn = document.querySelector('.custom-fragrance-modal-close');
  const cards = document.querySelectorAll('.custom-fragrance-card');
  const selectedList = document.getElementById('custom-fragrance-selected-list');
  const selectionCount = document.getElementById('custom-fragrance-selection-count');
  const addToCartBtn = document.getElementById('custom-fragrance-add-to-cart');
  const buyNowBtn = document.getElementById('custom-fragrance-buy-now');

  // Exit if elements don't exist (for pages without the tag)
  if (!openModalBtn || !modal) {
    return;
  }

  // --- Modal Controls ---
  function openModal() {
    modal.style.display = 'block';
    document.body.style.overflow = 'hidden';
  }
  function closeModal() {
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }
  openModalBtn.addEventListener('click', openModal);
  closeModalBtn.addEventListener('click', closeModal);
  window.addEventListener('click', function(event) {
    if (event.target == modal) { closeModal(); }
  });

  // --- Selection Logic ---
  function updateSelectionUI() {
    const checkedBoxes = document.querySelectorAll('.custom-fragrance-checkbox:checked');
    const checkedCount = checkedBoxes.length;
    
    // Update count and list
    selectionCount.textContent = checkedCount;
    selectedList.innerHTML = '';

    if (checkedCount > 0) {
      checkedBoxes.forEach(checkbox => {
        const li = document.createElement('li');
        li.textContent = checkbox.value;
        
        const removeSpan = document.createElement('span');
        removeSpan.className = 'custom-fragrance-remove-item';
        removeSpan.textContent = 'x';
        removeSpan.onclick = function() {
          const card = document.querySelector(`.custom-fragrance-card[data-fragrance="${checkbox.value}"]`);
          if(card) card.classList.remove('selected');
          checkbox.checked = false;
          updateSelectionUI();
        };

        li.appendChild(removeSpan);
        selectedList.appendChild(li);
      });
    }

    // Enable/disable buttons
    const isValid = checkedCount === 4;
    addToCartBtn.disabled = !isValid;
    buyNowBtn.disabled = !isValid;
  }

  // --- Handle Card Clicks ---
  cards.forEach(card => {
    card.addEventListener('click', function(event) {
      // Prevent clicks on the overlay from bubbling up to the card
      if (event.target.classList.contains('custom-fragrance-overlay')) {
        return;
      }
      
      const checkbox = card.querySelector('.custom-fragrance-checkbox');
      const checkedCount = document.querySelectorAll('.custom-fragrance-checkbox:checked').length;

      // If checking a new item and it would exceed 4, prevent it.
      if (!checkbox.checked && checkedCount >= 4) {
        alert('You can only select a maximum of 4 fragrances.');
        return;
      }
      
      // Toggle the checkbox and the 'selected' class
      checkbox.checked = !checkbox.checked;
      card.classList.toggle('selected', checkbox.checked);
      
      updateSelectionUI();
    });
  });

  // --- Handle Add to Cart / Buy Now ---
  function handleCartAction(redirect = false) {
    const selectedFragrances = Array.from(document.querySelectorAll('.custom-fragrance-checkbox:checked')).map(cb => cb.value);
    
    if (selectedFragrances.length !== 4) {
      alert('Please select exactly 4 fragrances to continue.');
      return;
    }
    
    // Find the variant ID from the main product form on the page
    const variantIdInput = document.querySelector('.product-variant-id');
    if (!variantIdInput) { 
      console.error('Product variant ID input not found!'); 
      alert('An error occurred. Please refresh the page and try again.');
      return; 
    }
    const variantId = variantIdInput.value;

    const formData = {
      'items': [{
        'id': variantId,
        'quantity': 1,
        'properties': { 'Selected Fragrances': selectedFragrances.join(', ') }
      }]
    };

    // Disable buttons temporarily
    addToCartBtn.disabled = true;
    buyNowBtn.disabled = true;

    fetch('/cart/add.js', { 
      method: 'POST', 
      headers: { 'Content-Type': 'application/json' }, 
      body: JSON.stringify(formData) 
    })
    .then(response => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.json();
    })
    .then(data => {
      console.log('Product added to cart:', data);
      closeModal();
      // Reset UI
      cards.forEach(card => card.classList.remove('selected'));
      document.querySelectorAll('.custom-fragrance-checkbox').forEach(cb => cb.checked = false);
      updateSelectionUI();
      // Refresh cart UI (standard Shopify event)
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      // Redirect if "Buy Now"
      if (redirect) { 
        setTimeout(() => { window.location.href = '/checkout'; }, 500); 
      }
    })
    .catch((error) => {
      console.error('Error:', error);
      alert('There was an error adding the product to the cart. Please try again.');
      // Re-enable buttons on error
      updateSelectionUI();
    });
  }
  
  addToCartBtn.addEventListener('click', () => handleCartAction(false));
  buyNowBtn.addEventListener('click', () => handleCartAction(true));
});